import PromiseBB from "bluebird";
import _ from "lodash";
import Debouncer from "../../util/Debouncer";
import { nativeImage } from "electron";
import * as fs from "../../util/fs";
import path from "path";
import extractExeIcon from "../../util/exeIcon";
import { ProcessCanceled } from "../../util/CustomErrors";
import StarterInfo from "../../util/StarterInfo";
import { truthy } from "../../util/util";
export const propOf = (name) => name;
export function isEqual(lhs, rhs) {
    return _.isEqual(lhs, rhs);
}
export function toDirname(filePath) {
    return path.dirname(filePath);
}
export function resolveToolName(tool) {
    return tool.name
        ? tool.name
        : tool.exePath
            ? path.basename(tool.exePath, path.extname(tool.exePath))
            : "";
}
export function splitCommandLine(input) {
    const res = [];
    let inBrackets = false;
    let startOffset = 0;
    const completeWord = (i) => {
        res.push(input.slice(startOffset, i));
        startOffset = i + 1;
    };
    for (let i = 0; i < input.length; ++i) {
        if (input[i] === " " && i > startOffset && !inBrackets) {
            completeWord(i);
        }
        else if (input[i] === '"') {
            inBrackets = !inBrackets;
        }
    }
    if (input.length > startOffset) {
        completeWord(input.length);
    }
    return res;
}
function setJumpList(categories) {
    return window.api.app.setJumpList(categories).catch((err) => {
        console.error(err);
    });
}
export function updateJumpList(starters) {
    if (process.platform !== "win32") {
        return;
    }
    return;
    // TODO the code below should work, except it doesn't filter out
    //   hidden tools, but due to a bug in electron the list doesn't
    //   get shown anyway.
    const userTasks = starters
        .filter((starter) => truthy(starter.exePath) &&
        Object.keys(starter.environment || {}).length === 0)
        .map((starter) => {
        const task = {
            arguments: starter.commandLine.join(" "),
            description: starter.name,
            iconIndex: 0,
            iconPath: StarterInfo.getIconPath(starter),
            program: starter.exePath,
            title: starter.name,
            workingDirectory: starter.workingDirectory,
        };
        return task;
    });
    setJumpList([
        {
            name: "Tools",
            type: "custom",
            items: userTasks,
        },
    ]);
}
export function toEditStarter(input) {
    const temp = {
        ...input,
        iconPath: StarterInfo.getIconPath(input),
    };
    temp.commandLine = temp.commandLine.join(" ");
    temp.environment = { ...input.environment };
    return temp;
}
export function toToolDiscovery(tool) {
    return {
        path: tool.exePath,
        hidden: false,
        custom: true,
        workingDirectory: tool.workingDirectory,
        id: tool.id,
        name: tool.name,
        executable: null,
        requiredFiles: [],
        environment: tool.environment,
        logo: `${tool.id}.png`,
        parameters: splitCommandLine(tool.commandLine),
        shell: tool.shell,
        detach: tool.detach,
        onStart: tool.onStart,
        defaultPrimary: tool.defaultPrimary,
        exclusive: tool.exclusive,
    };
}
function toPNG(inputPath, outputPath) {
    return fs.writeFileAsync(outputPath, nativeImage.createFromPath(inputPath).toPNG());
}
const updateImageDebouncer = new Debouncer((tool, imagePath) => useImage(tool, imagePath), 2000);
export function updateImage(tool, filePath, cb) {
    updateImageDebouncer.schedule(cb, tool, filePath);
}
function useImage(tool, filePath) {
    const destPath = tool.iconOutPath;
    if (destPath === filePath) {
        return PromiseBB.resolve();
    }
    return fs
        .statAsync(filePath)
        .catch((err) => PromiseBB.reject(new ProcessCanceled("invalid file")))
        .then((stats) => stats.isDirectory()
        ? PromiseBB.reject(new ProcessCanceled("is a directory"))
        : PromiseBB.resolve())
        .then(() => fs.ensureDirAsync(path.dirname(destPath)))
        .then(() => path.extname(filePath) === ".exe"
        ? extractExeIcon(filePath, destPath)
        : toPNG(filePath, destPath));
}
